export default __webpack_public_path__ + "static/1.5-Hidden-Label-DO-58d43787b6003557dcff76d68f9d66f8.png";